import { useQuery } from '@tanstack/react-query';
import { AuthRequiredError, unwrap } from '@truecare/api-client';
import { api } from '../api';

/**
 * Fetches `/api/v1/me/homecare/profile` — the homecare account for the
 * signed-in user (1:1 via the account_holder_user_id UNIQUE constraint).
 * Returns `null` on 401; backend 404s with `reason: 'no_homecare_account'`
 * if the user has no HOMECARE_CLIENT_USER persona.
 *
 * Consumers should gate the call via `enabled` on the role check so
 * non-homecare users don't 404 on every me-page render.
 */
export function useCurrentHomecare(opts: { enabled: boolean }) {
  return useQuery({
    queryKey: ['homecare', 'me'],
    queryFn: async () => {
      try {
        return await unwrap(api.GET('/api/v1/me/homecare/profile'));
      } catch (err) {
        if (err instanceof AuthRequiredError) return null;
        throw err;
      }
    },
    enabled: opts.enabled,
    retry: false,
  });
}
